<template>
  <VDialog
    v-model="isOpen"
    width="500px"
    persistent
  >
    <VBtn
      slot="activator"
      color="primary"
      class="ml-2"
    >
      {{ $nt('createEntry') }}
    </VBtn>

    <VCard>
      <VCardTitle>
        <span class="headline">
          {{ $nt('heading') }}
        </span>
      </VCardTitle>
      <VCardText>
        <VContainer grid-list-md>
          <VForm
            ref="agentEntry"
            v-model="isFormValid"
          >
            <VTextField
              v-model="agent.number"
              :error-messages="errorMessages.number"
              :label="$nt('number')"
              :rules="[$rules.isRequired]"
              class="xs12"
              required
            />
            <VTextField
              v-model="agent.first_name"
              :error-messages="errorMessages.first_name"
              :label="$nt('firstName')"
              :rules="[$rules.isRequired]"
              class="xs12"
              required
            />
            <VTextField
              v-model="agent.last_name"
              :error-messages="errorMessages.last_name"
              :label="$nt('lastName')"
              :rules="[$rules.isRequired]"
              class="xs12"
              required
            />
            <EmailInput
              v-model="agent.email"
              :email-error="errorMessages.email"
            />
            <SelectCity
              :value="{city: agent.city, zip: agent.zip }"
              :rules="[$rules.isRequired]"
              :error-messages="errorMessages.zip || errorMessages.city"
              class="xs12"
              :model-for-cls="selectCityModel"
              @input="({zip, name}) => Object.assign(agent, {zip, city: name})"
            />
          </VForm>
        </VContainer>
      </VCardText>
      <VCardActions>
        <VSpacer />
        <VBtn
          flat
          @click.native="closeDialog"
        >
          {{ $nt('cancel') }}
        </VBtn>
        <VBtn
          :disabled="!isFormValid || isLoading"
          color="primary"
          :loading="isLoading"
          @click.native="createEntry"
        >
          {{ $nt('create') }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script>
import EmailInput from '@/components/global-components/inputs/EmailInput'
import SelectCity from '@/components/global-components/inputs/SelectCity'
import AgencyManagerApi from '@/api/AgencyManagerApi'
import AdminApi from '@/api/AdminApi'
import { ability } from '@/permissions/rules'
import { mapGetters } from 'vuex'

export default {
  name: 'AgencyOverviewAgentsCreateEntry',
  components: { EmailInput, SelectCity },
  data () {
    return {
      isOpen: false,
      isFormValid: false,
      isLoading: false,
      agent: {
        first_name: '',
        last_name: '',
        email: '',
        zip: null,
        city: null
      },
      selectCityModel: {},
      errorMessages: {}
    }
  },
  computed: {
    ...mapGetters('agency', ['currentAgency']),
    canReadAllAgencies: () => ability.can('read', 'AllAgencies')
  },
  methods: {
    closeDialog () {
      this.isOpen = false
      this.$refs.agentEntry.reset()
      this.selectCityModel = {}
    },
    async createEntry () {
      this.isLoading = true
      try {
        this.canReadAllAgencies
          ? await this.$notification(AdminApi.createAgent(this.currentAgency.id, this.agent))
          : await this.$notification(AgencyManagerApi.createAgent(this.agent))
        this.$emit('onSuccess')
        this.closeDialog()
      } catch (e) {
        this.errorMessages = e
      }
      this.isLoading = false
    }
  },
  watch: {
    agent: {
      deep: true,
      handler () {
        this.errorMessages = {}
      }
    }
  }
}
</script>
